import { DateTime } from "luxon"

export const getDateRange = (startDate: DateTime, endDate: DateTime): DateTime[] => {
  if (!startDate.isValid || !endDate.isValid || startDate > endDate) return []

  const dateRange: DateTime[] = []
  let currentDate = startDate.startOf("day")
  const lastDate = endDate.startOf("day")

  while (currentDate <= lastDate) {
    dateRange.push(currentDate)
    currentDate = currentDate.plus({ days: 1 })
  }

  return dateRange
}

export const getCalendarDateRange = (startDate: DateTime, endDate: DateTime) =>
  getDateRange(startDate.startOf("week"), endDate.endOf("week"))

export const getDefaultWorkCycleDateRange = (now = DateTime.now()) => {
  const cycleStartMonth = now.day >= 25 ? now : now.minus({ months: 1 })

  return {
    endDate: cycleStartMonth.plus({ months: 1 }).set({ day: 24 }).startOf("day"),
    startDate: cycleStartMonth.set({ day: 25 }).startOf("day"),
  }
}
